//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions } from "vuex";

import router from "../../router";
export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
        sortBy: "id",
        descending: true,
      },
      orders: [],
      orderOptions: [
        { value: 100, name: this.$t("purchaseOrder.status-100") },
        { value: 200, name: this.$t("purchaseOrder.status-200") },
        { value: 300, name: this.$t("purchaseOrder.status-300") },
        { value: 400, name: this.$t("purchaseOrder.status-400") },
        { value: 500, name: this.$t("purchaseOrder.status-500") },
      ],
      orderStatuses: [100, 200, 300, 400, 500],
      filter: "",
      customers: [],
      orderId: 0,
      disableNewPurchase: false,
      title: this.$t("headers.purchaseOrder"),

      dense: true,

      columns: [
        {
          name: "id",
          align: "left",
          label: "Ordre nr",
          field: "id",
          sortable: true,
        },

        {
          name: "supplierName",
          align: "left",
          label: "Leverandør navn",
          field: "supplierName",
          sortable: true,
        },

        {
          name: "orderDate",
          align: "left",
          label: "Ord.Dato",
          field: "orderDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "left",
          label: "Lev.Dato",
          field: "deliveryDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "ourReference",
          align: "left",
          label: "Vår ref",
          field: "ourReference",
          sortable: true,
        },
        {
          name: "label",
          align: "left",
          label: "Merket",
          field: "label",
          sortable: true,
        },
        {
          name: "purchaseOrderStatusId",
          align: "left",
          label: "Ordre status",
          field: "purchaseOrderStatusId",
          format: (val) => this.$t("purchaseOrder.status-" + val),
          sortable: true,
        },
      ],
      columnsOrderLine: [
        {
          name: "productNumber",
          align: "left",
          label: "Produktnummer",
          field: (row) => row.productNumber,
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: "Produktnavn",
          field: (row) => row.productName,
          sortable: true,
        },

        {
          name: "quantity",
          align: "left",
          label: "Antall",
          field: (row) => row.numberOfItems,
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "left",
          label: "Lev.Dato",
          field: (row) => row.deliveryDate,
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    if (this.isRecevingMode) {
      this.disableNewPurchase = true;
      this.orderOptions = [
        { value: 300, name: this.$t("purchaseOrder.status-300") },
        { value: 400, name: this.$t("purchaseOrder.status-400") },
        { value: 500, name: this.$t("purchaseOrder.status-500") },
      ];
      this.orderStatuses = [300, 400, 500];
      this.title = this.$t("headers.receiveOrder");
    }
    await this.refresh();
  },

  computed: {
    isRecevingMode() {
      return this.$route.name === "PurchasesReceive";
    },
  },

  watch: {
    orderStatuses(newValue, oldValue) {
      if (newValue != oldValue) {
        this.refresh();
      }
    },

    isRecevingMode(newValue, oldValue) {
      if (newValue != oldValue) {
        if (this.isRecevingMode) {
          this.disableNewPurchase = true;
          this.orderOptions = [
            { value: 300, name: this.$t("purchaseOrder.status-300") },
            { value: 400, name: this.$t("purchaseOrder.status-400") },
            { value: 500, name: this.$t("purchaseOrder.status-500") },
          ];
          this.orderStatuses = [300, 400, 500];
          this.title = this.$t("headers.receiveOrder");
          this.refresh();
        } else {
          this.orderOptions = [
            { value: 100, name: this.$t("purchaseOrder.status-100") },
            { value: 200, name: this.$t("purchaseOrder.status-200") },
            { value: 300, name: this.$t("purchaseOrder.status-300") },
            { value: 400, name: this.$t("purchaseOrder.status-400") },
            { value: 500, name: this.$t("purchaseOrder.status-500") },
          ];
          this.orderStatuses = [100, 200, 300, 400, 500];
          this.disableNewPurchase = false;
          this.refresh();
        }
      }
    },
  },
  methods: {
    openOrder(orderId) {
      if (this.isRecevingMode) {
        router.push({ name: "PurchaseReceive", params: { id: orderId } });
      } else {
        router.push({ name: "Purchase", params: { id: orderId } });
      }
    },

    newPurchase() {
      console.log("newPurchase()");
      router.push({ name: "Purchase", params: { id: 0 } });
    },

    async refresh() {
      this.orders = [];

      this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.orders = await this.getPurchaseOrdersByStatuses(this.orderStatuses);

      setTimeout(() => {}, 500);
    },

    ...mapActions("main", ["getPurchaseOrders", "getPurchaseOrdersByStatuses"]),
  },
};
